/* ============================================================
   NORTHSHEEP — Recently viewed products
   localStorage-backed. Saves the current product on product pages,
   then renders the most-recent-first list (excluding the current
   product) into a horizontal card row. No external libraries, no
   product API fetching. Safe when localStorage is unavailable.
   ============================================================ */
(function () {
  'use strict';

  if (window.__nsRecentlyViewedLoaded) return;
  window.__nsRecentlyViewedLoaded = true;

  var STORAGE_KEY = 'northsheep_recently_viewed_products';

  function lsAvailable() {
    try {
      var k = '__ns_rv_test__';
      window.localStorage.setItem(k, '1');
      window.localStorage.removeItem(k);
      return true;
    } catch (e) {
      return false;
    }
  }

  function readList() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      var arr = JSON.parse(raw);
      return Array.isArray(arr) ? arr : [];
    } catch (e) {
      return [];
    }
  }

  function writeList(arr) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(arr));
    } catch (e) {
      /* quota / private mode — ignore */
    }
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  /* The heart's label for screen readers, in the store's language: the
     favourites root carries it (ns-favorites-drawer.liquid, data-add-aria).
     It was English on all five stores (proofread, 25 Sep 2026). */
  function favAria(title) {
    var root = document.querySelector('[data-ns-fav-root]');
    var tpl = (root && root.getAttribute('data-add-aria')) || 'Add to favourites: __T__';
    return tpl.replace('__T__', title);
  }

  function getCurrentProduct() {
    var node = document.querySelector('[data-ns-current-product]');
    if (!node) return null;
    try {
      var p = JSON.parse(node.textContent);
      if (!p || !p.handle) return null;
      return p;
    } catch (e) {
      return null;
    }
  }

  /* ---- ONE CARD PER VARIANT LOOKED AT (owner, 26 Sep 2026) ----
     "if they looked at a mokka sheepskin 150 it shows this product in the
     recently viewed instead of just its parent product", "so that i dont have
     to show available variants and thumbnails etc".

     An entry is a product (key: handle) or one of its variants (key:
     handle#id). A variant entry carries that variant's own photo, size,
     price, stock and address, and counts as a one-variant product, so its
     card adds exactly that variant.

     Per page visit there is ONE entry, rebuilt from the list as it was when
     the page opened (visit.snapshot): the variant the shopper arrived on
     (?variant=) or picks last. Clicking through five colours leaves one card,
     the last colour; a colour kept on an EARLIER visit stays a card of its
     own. A product card of the same product gives way to a variant card.
     Arriving on a product without choosing brings its most recent card
     forward rather than adding a second one. */
  var visit = null;

  function entryKey(e) {
    return (e.handle || '') + (e.vid ? '#' + e.vid : '');
  }

  function productEntry(current) {
    var e = {};
    for (var k in current) {
      if (Object.prototype.hasOwnProperty.call(current, k) && k !== 'vars' && k !== 'sel') e[k] = current[k];
    }
    return e;
  }

  /* `chosen`: the shopper picked this variant (or arrived on it with
     ?variant=). Only then does the card add it; the variant a page merely
     opened on - the first one in stock - gets View, so nobody is sold a size
     they never chose. Either way the card shows THAT variant's photo, size
     and price, never the product's "from" price (owner: "recently viewed now
     just pulls the cheapest variant ... this 34.95 variant is not even in
     stock"). */
  function variantEntry(current, vid, chosen) {
    var v = current.vars && current.vars[String(vid)];
    if (!v) return null;
    return {
      handle: current.handle,
      vid: String(vid),
      chosen: !!chosen,
      title: v.t ? (current.title || '') + ' | ' + v.t : current.title,
      url: v.u || current.url,
      image: v.i || current.image,
      price: v.p || current.price,
      compare_at_price: v.c || '',
      available: v.a !== false,
      type: current.type,
      vsize: v.s || '',
      vendor: v.s || current.vendor,
      variant_id: String(vid),
      // 1 = add this variant; more = View (see above).
      variants_count: chosen ? 1 : parseInt(current.variants_count, 10) || 2,
      sizes_html: '',
      swatches: [],
      swatch_more: 0
    };
  }

  function wasChosen(e) {
    // Entries from before the flag existed were all picked ones.
    return e.chosen === true || (e.chosen === undefined && String(e.variants_count) === '1');
  }

  function writeVisit(entry) {
    if (!visit || !entry) return;
    var key = entryKey(entry);
    var list = visit.snapshot.filter(function (p) {
      if (!p || !p.handle) return false;
      if (entryKey(p) === key) return false;
      if (entry.vid && p.handle === entry.handle && !p.vid) return false;
      return true;
    });
    entry.timestamp = Date.now();
    list.unshift(entry);
    // Cap stored products for performance.
    if (list.length > visit.maxStore) list = list.slice(0, visit.maxStore);
    writeList(list);
  }

  function saveCurrent(current, maxStore) {
    if (!current || !current.handle) return;
    visit = { handle: current.handle, snapshot: readList(), maxStore: maxStore };
    var entry = current.sel ? variantEntry(current, current.sel, true) : null;
    if (!entry) {
      for (var i = 0; i < visit.snapshot.length; i++) {
        var p = visit.snapshot[i];
        if (p && p.handle === current.handle) {
          // Back on a product seen before: its latest card, with today's data.
          entry = p.vid ? variantEntry(current, p.vid, wasChosen(p)) : null;
          break;
        }
      }
    }
    // Otherwise the variant the page opened on.
    if (!entry && current.shown) entry = variantEntry(current, current.shown, false);
    writeVisit(entry || productEntry(current));
  }

  /* The shopper picks another variant: Dawn's product-info.js publishes the
     new variant once the page has redrawn for it. Registered once; the
     current payload is read afresh, so a colour swap (a new product in
     <main>) is followed too. */
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var v = event && event.data && event.data.variant;
      var current = getCurrentProduct();
      if (!v || !v.id || !current || !visit || visit.handle !== current.handle) return;
      writeVisit(variantEntry(current, v.id, true));
    });
  }

  /* COMPACT CARD (owner, 26 Sep 2026: "can you change the recently viewed
     product section also to a compact design similar as the upsells? so no
     colour breadcrumbs, no size variants etc. just a compact row card with
     image, size, price, view/buy" - "im trying to clean a bit the amount of
     text and page lengths"). The buy box's "Often bought together" card: a
     3:4 photo shown whole on a sand card, the size, the price and one
     button at the foot. No swatches, no size pills, no heart; the name only
     when the section's "Show product names" is on. The whole card opens the
     product (an empty cover link, named for screen readers); a one-size
     piece gets a real Add button above it.
     Only the stored fields every saved entry already has are used, so a list
     saved before this design shows the same way. */
  var SIZE_RE = /\d\s*(?:cm|mm)\b|\d\s*[x×]\s*\d/i;

  function compactCardHtml(p, opts) {
    var url = p.url || '/products/' + (p.handle || '');
    var title = esc(p.title || '');
    var soldOut = p.available === false && !opts.hideSold;
    /* A size has a unit or an "x": the vendor field holds the size on these
       stores ("ca. 220 x 210 cm"), but on some products a brand or a store
       name ("Northsheep", "My Store 7"), which is not a size. */
    var sizeText = p.vsize || (p.vendor && SIZE_RE.test(p.vendor) ? p.vendor : '');
    var size = sizeText ? '<span class="ns-rv-c__meta">' + esc(sizeText) + '</span>' : '';
    var name = opts.showTitle ? '<span class="ns-rv-c__title">' + title + '</span>' : '';
    var price = '';
    /* A product card of a product with several variants was saved before the
       variant cards (26 Sep 2026): its price is the product's lowest, sold-out
       variants included. No price beats a wrong one; the next visit to that
       product replaces the card with the variant's own. */
    var staleFrom = !p.vid && (parseInt(p.variants_count, 10) || 0) > 1;
    if (opts.showPrice && p.price && !staleFrom) {
      price =
        '<span class="ns-rv-c__price">' + esc(p.price) +
        (opts.showCompare && p.compare_at_price ? ' <s class="ns-rv-c__compare">' + esc(p.compare_at_price) + '</s>' : '') +
        '</span>';
    }
    var vc = parseInt(p.variants_count, 10) || 0;
    var btn;
    if (vc === 1 && soldOut) {
      btn = '<span class="ns-rv-c__btn ns-rv-c__btn--sold" aria-hidden="true">' + esc(opts.soldOutText || 'Sold out') + '</span>';
    } else if (vc === 1 && p.variant_id && opts.showAtc) {
      btn =
        '<button type="button" class="ns-rv-c__btn ns-rv-c__btn--add" data-ns-rv-add="' + esc(p.variant_id) + '"' +
        ' aria-label="' + esc((opts.addShort || opts.addText || 'Add') + ': ' + (p.title || '')) + '">' +
        esc(opts.addShort || opts.addText || 'Add') +
        '</button>';
    } else {
      btn = '<span class="ns-rv-c__btn" aria-hidden="true">' + esc(opts.viewText || 'View') + '</span>';
    }
    return (
      '<li class="ns-rv__card ns-rv-c" data-ns-rv-handle="' + esc(p.handle || '') + '">' +
      '<a class="ns-rv-c__cover" href="' + esc(url) + '" aria-label="' + title + '"></a>' +
      '<span class="ns-rv-c__media" aria-hidden="true">' +
      (p.image ? '<img src="' + esc(p.image) + '" alt="" loading="lazy" width="600" height="800">' : '') +
      '</span>' +
      '<span class="ns-rv-c__text">' + name + size + price + '</span>' +
      btn +
      '</li>'
    );
  }

  function cardHtml(p, opts) {
    if (opts.compact) return compactCardHtml(p, opts);
    var url = p.url || '/products/' + (p.handle || '');
    var title = esc(p.title || '');
    // With "hide sold-out" on, a drawn card is re-checked and removed if it
    // really sold (pruneRow), so a stale stored flag must not label it.
    var soldOut = p.available === false && !opts.hideSold;

    var media = p.image
      ? '<img src="' + esc(p.image) + '" alt="' + title + '" loading="lazy" width="600" height="750">'
      : '';

    var badge =
      opts.showSoldOut && soldOut
        ? '<span class="ns-rv__soldout">' + esc(opts.soldOutText || 'Sold out') + '</span>'
        : '';

    var sizesHtml = p.sizes_html ? capSizes(p.sizes_html) : '';

    // Vendor caption (matches the collection / recommended cards).
    /* The sizes that are in stock, exactly as the collection cards show them —
       rendered by Liquid when the product was viewed and carried in the
       payload. Only when there are none does the vendor line stand in, which
       on a multi-size product reads "various sizes" and tells nobody
       anything. Our own markup, not user input, so it goes in as HTML. */
    var vendorHtml = sizesHtml
      ? sizesHtml
      : p.vendor
        ? '<span class="ns-rv__vendor">' + esc(p.vendor) + '</span>'
        : '';

    // Over-image add-to-cart (matches the collection card behaviour):
    // ONLY single-variant ("individual" / unique) products get a card button —
    // single variant -> instant AJAX add (sold out -> disabled). Multi-variant
    // products show NO button at all (no "Choose options").
    //
    // Rendered TWICE, like the collection card (snippets/ns-card-atc.liquid):
    // --desktop over the image (revealed on hover), --mobile under the price.
    // CSS shows one per breakpoint. On a phone the over-image button covered
    // the bottom of the photo and sat nowhere near where the collection grid
    // puts it.
    var atcBtn = '';
    if (opts.showAtc) {
      var vc = parseInt(p.variants_count, 10) || 0;
      if (vc > 1) {
        // Several sizes: no instant add (which size?), but not an empty gap
        // either — in a row of cards that all end in a button, the one without
        // looked broken. The same button, worded "View" (short enough for a
        // ~125px card button in every language), opens the product page where
        // the size is picked. Same wording as the collection cards.
        atcBtn =
          '<a class="ns-card-atc__btn ns-card-atc__btn--options" href="' +
          esc(url) +
          '"><span>' +
          esc(opts.viewText || 'View') +
          '</span></a>';
      } else if (vc === 1) {
        if (soldOut) {
          atcBtn =
            '<button type="button" class="ns-card-atc__btn" disabled aria-disabled="true"><span>' +
            esc(opts.soldOutText || 'Sold out') +
            '</span></button>';
        } else if (p.variant_id) {
          atcBtn =
            '<button type="button" class="ns-card-atc__btn" data-ns-rv-add="' +
            esc(p.variant_id) +
            '"><span>' +
            esc(opts.addText || 'Add to cart') +
            '</span></button>';
        }
      }
    }
    var atcHtml = atcBtn ? '<div class="ns-card-atc ns-card-atc--desktop ns-rv__atc">' + atcBtn + '</div>' : '';
    var atcMobileHtml = atcBtn ? '<div class="ns-card-atc ns-card-atc--mobile ns-rv__atc">' + atcBtn + '</div>' : '';

    // Favorite heart (top-right), only if the favorites feature is on the page.
    var favoriteBtn = '';
    if (document.querySelector('[data-ns-fav-root]')) {
      favoriteBtn =
        '<button type="button" class="ns-card-favorite-button" data-ns-fav-btn' +
        ' data-product-handle="' + esc(p.handle || '') + '"' +
        ' data-product-title="' + esc(p.title || '') + '"' +
        ' data-product-url="' + esc(url) + '"' +
        ' data-product-image="' + esc(p.image || '') + '"' +
        ' data-product-price="' + esc(p.price || '') + '"' +
        ' data-product-vendor="' + esc(p.vendor || '') + '"' +
        ' data-product-available="' + (p.available === false ? 'false' : 'true') + '"' +
        ' data-product-variant-id="' + esc(p.variant_id || '') + '"' +
        ' data-product-variants-count="' + esc(p.variants_count || '') + '"' +
        ' data-product-ratio="' + esc(p.ratio || p.aspect_ratio || '') + '"' +
        ' aria-pressed="false" aria-label="' + esc(favAria(p.title || '')) + '">' +
        ((window.NsFavorites && window.NsFavorites.heartSvg) ||
          '<svg class="ns-fav-heart" viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false"><path d="M12 20.3l-1.45-1.32C5.4 14.36 2 11.28 2 7.78 2 4.92 4.2 2.7 7 2.7c1.74 0 3.4.86 4.45 2.23l.55.72.55-.72A5.5 5.5 0 0 1 17 2.7c2.8 0 5 2.22 5 5.08 0 3.5-3.4 6.58-8.55 11.2L12 20.3z" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/></svg>') +
        '</button>';
    }

    // Variant image swatches (multi-variant products with 2+ distinct variant
    // images). Sized via the inherited --ns-sw-* vars on the RV root.
    var swatchesHtml = '';
    var swTotal = (p.swatches ? p.swatches.length : 0) + (p.swatch_more || 0);
    if (p.swatches && swTotal > 1) {
      var swInner = '';
      for (var si = 0; si < p.swatches.length; si++) {
        var s = p.swatches[si];
        if (!s || !s.img) continue;
        var soldCls = s.available === false ? ' ns-card-swatch--soldout' : '';
        swInner +=
          '<a class="ns-card-swatch' + soldCls + '" href="' + esc(s.url || url) + '" data-ns-swatch' +
          ' data-variant-img="' + esc(s.imgLarge || s.img) + '"' +
          ' title="' + esc(s.title || '') + '"' +
          ' aria-label="' + esc((p.title || '') + ' — ' + (s.title || '')) + '">' +
          '<img src="' + esc(s.img) + '" alt="' + esc(s.title || '') + '" loading="lazy"></a>';
      }
      if (p.swatch_more && p.swatch_more > 0) {
        swInner +=
          '<a class="ns-card-swatch ns-card-swatch--more" href="' +
          esc(url) +
          '" aria-label="' +
          p.swatch_more +
          ' more variants">+' +
          p.swatch_more +
          '</a>';
      }
      if (swInner) {
        /* Same position as the collection cards: in the card's text, between
           the size line and the price. Over the picture the thumbnails sat on
           top of the View / Add button and made it unreachable. The theme
           setting decides, so both places move together. */
        swatchesHtml =
          '<div class="ns-card-swatches ns-card-swatches--' +
          (opts.swatchPosition === 'image' ? 'image' : 'info') +
          '" data-ns-card-swatches data-swap="' +
          (opts.swatchSwap ? '1' : '0') +
          '">' +
          swInner +
          '</div>';
      }
    }

    var priceHtml = '';
    if (opts.showPrice && p.price) {
      if (opts.showCompare && p.compare_at_price) {
        priceHtml =
          '<div class="price price--on-sale">' +
          '<span class="ns-rv__price-sale">' + esc(p.price) + '</span>' +
          '<span class="ns-rv__price-compare">' + esc(p.compare_at_price) + '</span>' +
          '</div>';
      } else {
        priceHtml = '<div class="price"><span class="ns-rv__price-regular">' + esc(p.price) + '</span></div>';
      }
    }

    return (
      '<li class="ns-rv__card" data-ns-rv-handle="' + esc(p.handle || '') + '">' +
      '<div class="card-wrapper product-card-wrapper">' +
      '<div class="card card--standard card--media">' +
      '<div class="card__media">' +
      '<a href="' + esc(url) + '" tabindex="-1" aria-hidden="true">' + media + '</a>' +
      badge +
      atcHtml +
      (opts.swatchPosition === 'image' ? swatchesHtml : '') +
      '</div>' +
      favoriteBtn +
      '<div class="card__content">' +
      '<div class="card__information">' +
      '<h3 class="card__heading"><a class="full-unstyled-link" href="' + esc(url) + '">' + title + '</a></h3>' +
      vendorHtml +
      (opts.swatchPosition === 'image' ? '' : swatchesHtml) +
      priceHtml +
      atcMobileHtml +
      '</div>' +
      '</div>' +
      '</div>' +
      '</div>' +
      '</li>'
    );
  }

  /* Two pills, then the count.

     The Liquid asks for two, but this markup was rendered and stored when the
     product was last VIEWED — a card saved before that cap existed still
     carries five, and would keep carrying them until the shopper happened to
     open that product again. So the cap is applied here as well, to whatever
     came out of storage, and the breakpoint markers the snippet renders for a
     full-width card are collapsed into the single count this narrow one
     needs. */
  var RV_MAX_PILLS = 2;

  function capSizes(html) {
    if (!html) return '';
    var wrap = document.createElement('div');
    wrap.innerHTML = html;
    var row = wrap.firstElementChild;
    if (!row) return '';

    var pills = row.querySelectorAll('.ns-card-sizes__pill');
    if (!pills.length) return '';

    // Whatever the snippet had already hidden, plus whatever we hide now.
    var deskMore = row.querySelector('.ns-card-sizes__more--desk');
    var alreadyHidden = deskMore ? parseInt(deskMore.textContent.replace(/\D/g, ''), 10) || 0 : 0;
    var total = pills.length + alreadyHidden;

    var marks = row.querySelectorAll('.ns-card-sizes__more');
    for (var m = 0; m < marks.length; m++) marks[m].parentNode.removeChild(marks[m]);

    for (var i = pills.length - 1; i >= RV_MAX_PILLS; i--) pills[i].parentNode.removeChild(pills[i]);

    var rest = total - Math.min(total, RV_MAX_PILLS);
    if (rest > 0) {
      var span = document.createElement('span');
      span.className = 'ns-card-sizes__more';
      span.textContent = '+' + rest;
      row.appendChild(span);
    }

    /* AND THIS ROW IS NOW FINISHED WITH.
       ns-card-size-pills.js fits every .ns-card-sizes[data-total] on the page
       to two lines, and adds a "+N" of its own when it hides something. These
       cards are half the width of a collection card, so they are capped here
       instead - at two pills, flat - and the two cappers were both appending
       a chip. That is the "+1 +1" the owner sees: not one count rendered
       twice, but two different scripts each reporting their own.
       Dropping data-total takes this row out of the fitter's query, so the
       cap applied here is the only one. */
    row.removeAttribute('data-total');

    // --mobN hides pills by position on phones; there are only two left.
    row.className = row.className.replace(/\s*ns-card-sizes--mob\d+/g, '');

    /* BRING A STALE ROW UP TO THE CURRENT DESIGN.

       The markup above was stored when the product was last viewed. Change
       the size row's design and every card already in storage keeps the old
       one until the shopper happens to open that product again — which is why
       these cards were still showing "M · approx. 100 cm" in full while the
       collection grid had moved to codes. The design in force is printed on
       the section by Liquid, so this follows the setting rather than assuming
       one, and the same shortening rule is applied: a leading size code, or
       the part before a bracket, with the rest moved to the caption line. */
    var host = document.querySelector('[data-ns-sizes-design]');
    var design = host ? host.getAttribute('data-ns-sizes-design') : 'rail';
    /* Rebuilt, not appended: appending left "--rail --rail" on a card that
       had already been through here once. */
    var keep = row.className.split(/\s+/).filter(function (cl) {
      return cl && !/^ns-card-sizes--(rail|squares|pills|full)$/.test(cl);
    });
    keep.push('ns-card-sizes--' + design);
    row.className = keep.join(' ');

    if (design !== 'full') {
      var CODES = ',XXS,XS,S,M,L,XL,XXL,XXXL,XXXXL,XXXXXL,2XL,3XL,4XL,5XL,';
      var chosenLabel = '';
      var left = row.querySelectorAll('.ns-card-sizes__pill');
      for (var k = 0; k < left.length; k++) {
        var full = (left[k].getAttribute('data-ns-vlabel') || left[k].textContent).trim();
        var short = '';
        if (full.indexOf(' (') > -1) {
          short = full.split(' (')[0].trim();
          full = full.split(' (')[1].replace(')', '').trim();
        } else {
          var first = full.split(' ')[0];
          if (CODES.indexOf(',' + first.toUpperCase() + ',') > -1) short = first;
        }
        if (!short) continue;
        left[k].textContent = short;
        /* The marked pill names the caption. Older stored cards have no mark
           at all — there the first size is the one the price quotes, which is
           the same rule Liquid follows. */
        if (left[k].classList.contains('ns-card-sizes__pill--quoted')) chosenLabel = full;
        else if (!chosenLabel && k === 0) chosenLabel = full;
      }
      /* ONE CAPTION, NEVER TWO. Markup stored AFTER the caption existed
         already carries its own, and adding a second printed every size
         twice. Whatever is already there wins — it came from Liquid — and a
         new one is only built when the stored card predates it. */
      var caps = wrap.querySelectorAll('.ns-card-sizes__chosen');
      for (var c = caps.length - 1; c > 0; c--) caps[c].parentNode.removeChild(caps[c]);
      if (!caps.length && chosenLabel) {
        var cap = document.createElement('div');
        cap.className = 'ns-card-sizes__chosen';
        cap.setAttribute('data-ns-size-caption', '');
        cap.textContent = chosenLabel;
        row.parentNode.insertBefore(cap, row.nextSibling);
      }
    }
    return wrap.innerHTML;
  }

  function addToCart(variantId, btn) {
    var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    var url = (window.routes && window.routes.cart_add_url) || '/cart/add';

    var config;
    try {
      config = fetchConfig('javascript'); // Dawn helper
    } catch (e) {
      config = { method: 'POST', headers: {} };
    }
    config.headers = config.headers || {};
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    var fd = new FormData();
    fd.append('id', variantId);
    fd.append('quantity', '1');
    if (cart && typeof cart.getSectionsToRender === 'function') {
      fd.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
      fd.append('sections_url', window.location.pathname);
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
    }
    config.body = fd;

    btn.setAttribute('aria-disabled', 'true');
    btn.classList.add('loading');

    fetch(url, config)
      .then(function (r) { return r.json(); })
      .then(function (resp) {
        if (resp && resp.status) {
          /* Refused (e.g. the variant sold since it was viewed - a variant
             card remembers the stock of that moment). Say so on the button
             instead of doing nothing. */
          var root = btn.closest('[data-ns-rv]');
          var label = btn.querySelector('span') || btn;
          label.textContent = (root && root.getAttribute('data-soldout-text')) || 'Sold out';
          btn.disabled = true;
          btn.classList.add('ns-rv-c__btn--sold');
          return;
        }
        if (cart && typeof cart.renderContents === 'function') {
          if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
          cart.renderContents(resp); // opens the cart drawer / notification
        } else {
          window.location = (window.routes && window.routes.cart_url) || '/cart';
          return;
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          try {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'ns-recently-viewed',
              productVariantId: variantId,
              cartData: resp
            });
          } catch (e) {}
        }
      })
      .catch(function () { /* ignore network errors */ })
      .finally(function () {
        btn.classList.remove('loading');
        btn.removeAttribute('aria-disabled');
      });
  }

  function setupAtc(row) {
    if (row.dataset.nsAtcReady === '1') return;
    row.dataset.nsAtcReady = '1';
    row.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('[data-ns-rv-add]') : null;
      if (!btn) return;
      e.preventDefault();
      if (btn.getAttribute('aria-disabled') === 'true') return;
      addToCart(btn.getAttribute('data-ns-rv-add'), btn);
    });
  }

  function setupArrows(root, row) {
    var prev = root.querySelector('[data-ns-rv-prev]');
    var next = root.querySelector('[data-ns-rv-next]');

    function update() {
      var overflow = row.scrollWidth - row.clientWidth;
      if (overflow > 4) {
        root.classList.add('ns-recently-viewed--overflow');
      } else {
        root.classList.remove('ns-recently-viewed--overflow');
      }
      if (prev) prev.disabled = row.scrollLeft <= 2;
      if (next) next.disabled = row.scrollLeft >= overflow - 2;
    }

    function step(dir) {
      var amount = Math.max(row.clientWidth * 0.8, 200);
      row.scrollBy({ left: dir * amount, behavior: 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
    row.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    window.addEventListener('load', update);
    if (window.ResizeObserver) new ResizeObserver(update).observe(row);
    update();
  }

  function sectionOf(root) {
    return root.closest('[data-ns-rv-section]') || root;
  }
  function hideSection(root) {
    var s = sectionOf(root);
    s.setAttribute('hidden', '');
    s.style.display = 'none';
  }
  function showSection(root) {
    var s = sectionOf(root);
    s.removeAttribute('hidden');
    s.style.display = '';
  }

  /* ---- Sold / removed products (2026-09-16) ----
     The list lives in the shopper's browser, so it kept showing hides that
     sold weeks ago — and since the Flow deletes sold unique hides after 60
     days, those cards became dead links. ns-product-status.js asks the shop.

     'gone'    → removed from the stored list for good.
     'soldout' → kept in storage (a random sheepskin or blanket comes back),
                 but not shown while the "hide sold-out" setting is on.
     'unknown' → left exactly as it is. */
  function withStatus(fn) {
    if (window.NsProductStatus) { fn(window.NsProductStatus); return; }
    // Both scripts are deferred and the status script comes first in the
    // section, so this is only a safety net for an unusual load order.
    window.addEventListener('load', function () {
      if (window.NsProductStatus) fn(window.NsProductStatus);
    }, { once: true });
  }

  /* Only a FRESH answer from the shop hides a card before it is drawn. The
     stored `available` flag is not enough on its own: a card hidden on that
     flag is never drawn, so never re-checked, so a wrong flag would hide an
     in-stock product for good (which is what a bad first deploy of the status
     check did). A card sold since it was viewed is drawn, checked, and taken
     out a moment later instead. */
  function showable(p, api) {
    if (!p || !p.handle) return false;
    var s = api ? api.cached(p.handle) : null;
    if (s === 'gone') return false;
    if (s === 'soldout' && api.hideSoldOut()) return false;
    return true;
  }

  function pruneRow(root, row) {
    withStatus(function (api) {
      var cards = row.querySelectorAll('[data-ns-rv-handle]');
      var handles = [];
      for (var i = 0; i < cards.length; i++) handles.push(cards[i].getAttribute('data-ns-rv-handle'));
      if (!handles.length) return;

      api.check(handles).then(function (res) {
        var hide = api.hideSoldOut();
        var removedAny = false;

        var live = row.querySelectorAll('[data-ns-rv-handle]');
        for (var j = 0; j < live.length; j++) {
          var s = res[live[j].getAttribute('data-ns-rv-handle')];
          if (s === 'gone' || (hide && s === 'soldout')) {
            live[j].parentNode.removeChild(live[j]);
            removedAny = true;
          }
        }

        // Keep storage in step: drop the gone ones, record fresh availability.
        var list = readList();
        var changed = false;
        list = list.filter(function (p) {
          var st = p && res[p.handle];
          if (st === 'gone') { changed = true; return false; }
          // 'ok' says the PRODUCT can be bought, not that this card's variant
          // can: a variant card keeps its own flag.
          if (st === 'ok' && p.available === false && !p.vid) { p.available = true; changed = true; }
          if (st === 'soldout' && p.available !== false) { p.available = false; changed = true; }
          return true;
        });
        if (changed) writeList(list);

        if (!removedAny) return;
        if (!row.querySelector('[data-ns-rv-handle]')) {
          if (root.getAttribute('data-ns-rv-design') !== 'true') hideSection(root);
          return;
        }
        if (window.nsScrollRowSync) window.nsScrollRowSync();
      });
    });
  }

  function init(root) {
    if (!root || root.dataset.nsRvReady === '1') return;
    root.dataset.nsRvReady = '1';

    var row = root.querySelector('[data-ns-rv-row]');
    if (!row) return;

    var design = root.getAttribute('data-ns-rv-design') === 'true';
    var maxStore = parseInt(root.getAttribute('data-max-store'), 10) || 24;
    var maxDisplay = parseInt(root.getAttribute('data-max-display'), 10) || 16;
    var opts = {
      showPrice: root.getAttribute('data-show-price') !== 'false',
      showCompare: root.getAttribute('data-show-compare') !== 'false',
      showSoldOut: root.getAttribute('data-show-soldout') !== 'false',
      showAtc: root.getAttribute('data-show-atc') !== 'false',
      soldOutText: root.getAttribute('data-soldout-text') || 'Sold out',
      addText: root.getAttribute('data-add-text') || 'Add to cart',
      chooseText: root.getAttribute('data-choose-text') || 'Choose options',
      viewText: root.getAttribute('data-view-text') || 'View',
      // Section -> Card design -> Compact (26 Sep 2026).
      compact: root.getAttribute('data-ns-rv-style') === 'compact',
      showTitle: root.getAttribute('data-show-title') !== 'false',
      addShort: root.getAttribute('data-add-short-text') || '',
      swatchSwap: root.getAttribute('data-ns-swatch-swap') !== 'false',
      // Theme settings → "Where the swatches sit". Defaults to the card text.
      swatchPosition: root.getAttribute('data-ns-swatch-position') || 'info',
      hideSold: !!(window.NsProductStatus && window.NsProductStatus.hideSoldOut())
    };

    var current = getCurrentProduct();

    if (!lsAvailable()) {
      // Private mode / storage blocked: keep the editor placeholders, hide live.
      if (design) {
        showSection(root);
        setupArrows(root, row);
      } else {
        hideSection(root);
      }
      return;
    }

    if (current) saveCurrent(current, maxStore);

    var list = readList();
    if (current && current.handle) {
      list = list.filter(function (p) {
        return p && p.handle && p.handle !== current.handle;
      });
    }
    // Leave out what is already known to be sold or gone BEFORE capping, so
    // the row still fills up to maxDisplay with products that can be bought.
    var statusApi = window.NsProductStatus || null;
    list = list.filter(function (p) { return showable(p, statusApi); });
    list = list.slice(0, maxDisplay);

    if (list.length === 0) {
      if (design) {
        // Editor: keep the Liquid placeholder cards so the section is editable.
        showSection(root);
        setupArrows(root, row);
      } else {
        hideSection(root);
      }
      return;
    }

    var html = '';
    for (var i = 0; i < list.length; i++) html += cardHtml(list[i], opts);
    row.innerHTML = html;
    showSection(root);

    /* The cards land inside the track, not as direct children of the
       [data-ns-srow] host, so the shared row component's MutationObserver
       never fires for them. Tell it directly. */
    if (window.nsScrollRowSync) window.nsScrollRowSync();
    setupArrows(root, row);
    setupAtc(row);
    if (window.NsFavorites && window.NsFavorites.sync) window.NsFavorites.sync();
    // Re-check what is shown; anything sold or removed since is taken out.
    if (!design) pruneRow(root, row);
  }

  function boot() {
    var roots = document.querySelectorAll('[data-ns-rv]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  /* A colour swap (ns-colour-siblings.js) replaces <main>, this section
     included, and this file — run again — stops at the guard at the top. The
     new section stayed display:none: measured, 14 cards before a swap, none
     after (audit, 23 Sep 2026). The new root is not marked ready, so boot()
     builds it for the product now on screen and leaves anything built alone. */
  document.addEventListener('ns:colour-swapped', boot);
  // Re-init when a section is (re)rendered in the theme editor.
  document.addEventListener('shopify:section:load', function (e) {
    var container = e && e.target ? e.target.querySelector('[data-ns-rv]') : null;
    if (container) {
      container.dataset.nsRvReady = '';
      init(container);
    } else {
      boot();
    }
  });
})();
